import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Layout from '../components/Layout';
import {api} from '../../api';

export default function BannedList() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api('/banned-items').then(r => r.ok ? r.json() : []).then(setItems);
  }, []);

  return (
    <Layout>
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Banned List</h2>
        <Link to="/banned-list/new" className="px-4 py-2 bg-rose-600 text-white rounded-lg hover:bg-rose-700">Add Entry</Link>
      </div>

      <div className="bg-white rounded-lg shadow overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Name</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden sm:table-cell">Reason</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden sm:table-cell">Added By</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {items.map(item => (
              <tr key={item.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">
                  <Link to={`/banned-list/${item.id}`} className="text-rose-600 hover:text-rose-800 font-medium">{item.name}</Link>
                </td>
                <td className="px-6 py-4 text-gray-600 hidden sm:table-cell">{item.reason}</td>
                <td className="px-6 py-4 text-gray-600 hidden sm:table-cell">{item.addedBy}</td>
                <td className="px-6 py-4 text-gray-600">{new Date(item.createdAt).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {items.length === 0 && <div className="text-center py-12 text-gray-500">No banned items found.</div>}
      </div>
    </Layout>
  );
}
